import { Button2, Button2Props } from './Button2';
export const Button = Button2;
export type ButtonProps = Button2Props;
